export default {
  props: {
    hint: String,
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
    width: Number,
    height: Number,
    PropertyURI: String,
    event: String,
    round: String,
    fontStyle: {
      type: String,
      default: 'normal',
    },
    properties: {
      type: Object,
      default: function () {
        return {};
      }
    },
    events: {
      type: Object,
      default: function () {
        return {};
      }
    },
    ident: {
      type: String,
      default: '',
    },
    disabled: {
      Boolean,
      default: false
    },
    absolut: {
      Boolean,
      default: true
    },
  },
  computed: {
    value: function () {
      if (typeof this.properties[this.PropertyURI] == "undefined") {
        return 0
      }
      else {
        return this.properties[this.PropertyURI]?.outputValue?.value;
      }
    }
  },
  mounted: function () {
    if (this.absolut)
      this.$el.style.position = "absolute";
    this.$el.style.height = this.height + "px";
    this.$el.style.width = this.width + "px";
    this.$el.style.left = this.x + "px";
    this.$el.style.top = this.y + "px";
  },

}      